<style src="@/assets/css/cockpit.css"></style>
<template>
  <div id="as-cockpit">
    <a href="#" @click.prevent="showToolbar = !showToolbar">
      <font-awesome-icon :icon="['fas', 'cog']" />
    </a>
    <div
      class="toolbar"
      v-if="showToolbar"
      @click.prevent="showToolbar = !showToolbar"
    >
      <ul>
        <li v-if="$store.state.user.status === 1">
          <a href="#" @click.prevent="showModal('catalog')">Каталог</a>
        </li>
        <li v-if="$store.state.user.status === 1">
          <a href="#" @click.prevent="showModal('partners')">Партнёры</a>
        </li>
        <li
          v-if="
            $store.state.user.status === 1 || $store.state.user.status === 3
          "
        >
          <a href="#" @click.prevent="showModal('infoPage')">Инфо страницы</a>
        </li>
        <li v-if="$store.state.user.status === 1">
          <a href="#" @click.prevent="showModal('orders')">Заказы</a>
        </li>
        <li v-if="$store.state.user.status === 1">
          <a href="#" @click.prevent="showModal('users')">Пользователи</a>
        </li>
      </ul>
    </div>
    <Catalog ref="catalog" />
    <EditPage ref="editModal" />
    <Users ref="users" />
    <Orders ref="orders" />
    <Partners ref="partners" />
    <InfoPage ref="infoPage" />
  </div>
</template>

<script>
import EditPage from "@/components/cockpit/modals/editPage.vue";
import Catalog from "@/components/cockpit/modals/catalog.vue";
import Users from "@/components/cockpit/modals/users.vue";
import Orders from "@/components/cockpit/modals/orders.vue";
import Partners from "@/components/cockpit/modals/partners.vue";
import InfoPage from "@/components/cockpit/modals/infoPage.vue";

export default {
  data() {
    return {
      showToolbar: false
    };
  },
  methods: {
    showModal(target) {
      this.sm = true;
      this.$refs[target].show = true;
      document.body.classList.add("modal-open");
    },
    editPage() {
      console.log("Edit page");
    },
    removePage() {
      console.log("Remove page");
    }
  },
  components: {
    EditPage,
    Catalog,
    Users,
    Orders,
    Partners,
    InfoPage
  }
};
</script>
